import React, { useEffect, useState, useRef } from 'react';
import styles from './AdViseFileViewer.module.css';
import LazyLoad from 'react-lazyload';
import api from '../../../api';
import axios from 'axios'
import AutoCompleteInput from '../SubComponent/AutoCompleteInput';
import { copyToClipboard, josa, openInstagramMedia } from '../../../util';

const AdViseFileViewer = ({ setAdViseStep, stepProps, setStepProps, marginTop }) => {
    const [files, setFiles] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [regionFilter, setRegionFilter] = useState('전체');
    const [categoryFilter, setCategoryFilter] = useState('전체');
    const [statusFilter, setStatusFilter] = useState('전체');
    const [currentPage, setCurrentPage] = useState(0);
    const [selectedFile, setSelectedFile] = useState(null);
    const [showImages, setShowImages] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [captionModalOpen, setCaptionModalOpen] = useState(false);
    const [captionModalText, setCaptionModalText] = useState('');

    // 본문 모달 열기
    const openCaptionModal = (text) => {
        setCaptionModalText(text || '본문이 없습니다.');
        setCaptionModalOpen(true);
    };

    const adviseRefs = useRef({});
    const scrollContainerRef = useRef(null);

    const REGION_OPTIONS = ['전체','공식','서울','부산','인천','대구','대전','광주','울산','세종','경기','충북','충남','전남','경북','경남','강원','전북','제주','전지역','테스트'];
    const CATEGORY_OPTIONS = ['전체', '음식점', '주점', '카페디저트', '팝업스토어', '오락액티비티', '문화예술', '숙소', '휴식힐링', '기타'];

    const getAdviseFiles = async () => {
        try {
            const response = await api.get('/advise/admin/list-files');
            setFiles(response.data);
        } catch (error) {
            console.error('Error fetching advise files:', error);
        }
    };

    const getAdviseProps = async (adviseId) => {
        try {
            const response = await api.get('/advise/admin/advise-props', {
                params: { id: adviseId }
            });
            return response.data.props;
        } catch (error) {
            console.error('Error fetching advise files:', error);
            return;
        }
    };

    const handleClone = async (id, currentName) => {
        const rawName = window.prompt('복제될 프로젝트 이름을 입력해주세요:', currentName+'_copy');
        if (rawName === null) {
            return;
        }
        const newName = rawName.trim();
        if (newName === '') {
            // 확인만 누르고 빈 문자열을 입력한 경우
            alert('유효한 프로젝트 이름을 입력해야 합니다.');
            return;
        }
        if (newName === currentName) {
            alert('기존 프로젝트 이름과 동일합니다. 다른 이름을 입력해주세요.');
            return;
        }

        try {
            // 3) 서버에 복제 요청
            const { data } = await api.post('/advise/admin/clone-file', {
                id,
                newName
            });

            alert(`프로젝트가 복제되었습니다!`);
            // 4) 목록 갱신
            await getAdviseFiles();
        } catch (err) {
            console.error('복제 실패:', err);

            // 중복 이름 충돌 처리
            if (err.response?.status === 409 && err.response.data?.error === 'DUPLICATE_NAME') {
                alert('이미 존재하는 파일명입니다. 다른 이름을 입력해주세요.');
            } else {
                alert('프로젝트 복제에 실패했습니다. 다시 시도해주세요.');
            }
        }
    };

    const handleRename = async (id, currentName) => {
        const raw = window.prompt('새 프로젝트 이름을 입력해주세요:', currentName);
        if (raw === null) {
            return;
        }
        const newName = raw.trim();
        if (newName === '') {
            alert('유효한 프로젝트 이름을 입력해야 합니다.');
            return;
        }
        if (newName === currentName) {
            alert('현재 프로젝트 이름과 동일합니다. 다른 이름을 입력해주세요.');
            return;
        }

        try {
            const { data: updatedFile } = await api.patch('/advise/admin/update-name', { id, newName });
            setFiles(files =>
                files.map(f => f.id === id ? updatedFile : f)
            );
            alert('프로젝트 이름이 변경되었습니다.');
        } catch (err) {
            if (err.response?.status === 409 && err.response.data.error === 'DUPLICATE_NAME') {
                alert('이미 존재하는 파일명입니다. 다른 이름을 입력해주세요.');
            } else {
                console.error(err);
                alert('이름 변경에 실패했습니다.');
            }
        }
    };

    const handleRegionChange = async (id, region) => {
        try {
            const { data: updatedFile } = await api.patch('/advise/admin/update-region', { id, region });
            setFiles(files =>
                files.map(f => f.id === id ? updatedFile : f)
            );
        } catch (err) {
            console.error('Region 변경 실패', err);
            alert('Region 변경에 실패했습니다.');
        }
    };

    const handleResourceStatusChange = async (fileId, authorName, newStatus) => {
        const resourceIds = [];

        currentFilePage.find(file => (file.id == fileId))?.resources.forEach(res => {
            if(res.author_name==authorName)
                resourceIds.push(res.id);
        });

        resourceIds.forEach(resId => {
            patchResourceStatusChange(resId, newStatus);
        });
    }

    const patchResourceStatusChange = async (resourceId, newStatus) => {
        try {
            const { data: updated } = await api.patch(
            `/advise/admin/resource/${resourceId}/status`,
            { status: newStatus }
            );

            setFiles(files =>
                files.map(file => {
                    // 이 파일이 해당 resourceId를 가지고 있으면
                    if (file.resources.some(r => r.id === resourceId)) {
                        return {
                            ...file,
                            resources: file.resources.map(r =>
                            r.id === resourceId
                                ? { ...r, status: updated.status }
                                : r
                            )
                        };
                    }
                    // 아니면 그대로
                    return file;
                })
            );
        } catch (err) {
            console.error('리소스 상태 변경 실패:', err);
            alert('상태 변경에 실패했습니다.');
        }
    };

    const filteredFiles = files.filter(file => {
        const regionOk = regionFilter === '전체'
            || file.region === regionFilter;

        const categoryOk =
            categoryFilter === '전체'
            || (categoryFilter === '기타' && !file.hotple)
            || file.hotple?.main_category === categoryFilter;

        const textOk = !filterText
            ? true
            : file.name.toLowerCase().includes(filterText.toLowerCase())
            || file.hotple?.name.toLowerCase().includes(filterText.toLowerCase());

        const res = Array.isArray(file.resources) ? file.resources : [];
        const allApproved = res.length > 0 && res.every(r => r.status === '승인 완료');
        const none       = res.length === 0;
        const anyNeed    = res.some(r => r.status === '승인 필요');

        const statusOk =
            statusFilter === '전체'
            || (statusFilter === '업로드 완료' && file.is_uploaded)
            || (statusFilter === '업로드 대기'
                && !file.is_uploaded
                && (none || allApproved)
            )
            || (statusFilter === '승인 필요'
                && !file.is_uploaded
                && anyNeed
            )
            || (statusFilter === '승인 대기'
                && !file.is_uploaded
                && !none
                && !allApproved
                && !anyNeed
            );

        return regionOk && categoryOk && textOk && statusOk;
    });

    const FILES_PER_PAGE = 100;
    const totalPages = Math.ceil(filteredFiles.length / FILES_PER_PAGE);
    const currentFilePage = filteredFiles.slice(
        currentPage * FILES_PER_PAGE,
        currentPage * FILES_PER_PAGE + FILES_PER_PAGE
    );

    const handleFilterTextChange = (text) => {
        setFilterText(text);
        resetPaging();
    };
    
    const whenScrollTopClicked = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const whenDeleteButtonClicked = async (id) => {
        if (!window.confirm('정말 이 AdVise 프로젝트를 삭제하시겠습니까?')) {
          return;
        }
      
        try {
          await api.delete('/advise/admin/delete-file', { params: { id } });

          setFiles((prev) => prev.filter((f) => f.id !== id));

          if (selectedFile?.id === id) {
            setSelectedFile(null);
          }
        } catch (error) {
          console.error('삭제 중 오류 발생:', error);
          alert('삭제에 실패했습니다. 다시 시도해주세요.');
        }
      };

    const downloadAllContents = async (urls) => {
        if (!window.confirm('해당 프로젝트의 모든 콘텐츠를 다운로드 받으시겠어요?')) {
          return;
        }
        
        for (const url of urls) {
            try {
            // 1) fetch 로 파일을 받아와서 Blob 으로 변환
            const res = await fetch(url);
            if (!res.ok) throw new Error(`Failed to fetch ${url}`);
            const blob = await res.blob();

            // 2) Blob 을 가리키는 Object URL 생성
            const objectUrl = URL.createObjectURL(blob);

            // 3) 다운로드용 <a> 태그 만들고 프로그램matically click
            const link = document.createElement('a');
            link.href = objectUrl;
            // 파일명은 URL 마지막 부분에서 추출
            const filename = url.split('/').pop().split('?')[0] || 'download';
            link.download = filename;
            document.body.appendChild(link);
            link.click();

            // 4) 정리
            document.body.removeChild(link);
            URL.revokeObjectURL(objectUrl);

            // (선택) 약간의 지연을 두면 너무 빨리 successive 클릭이 날아가는 걸 방지할 수 있습니다.
            await new Promise(r => setTimeout(r, 200));
            } catch (err) {
            console.error('다운로드 실패:', err);
            }
        }
    };

    function extractOfficialImageUrls(place) {
        const origins = [];
        if (!place || typeof place !== 'object') return origins;

        const root = place.ROOT_QUERY;
        if (!root || typeof root !== 'object') return origins;

        // 1) placeDetail(...) 객체 찾기
        const detailEntry = Object.entries(root)
        .find(([key, val]) =>
            key.startsWith("placeDetail") &&
            val && typeof val === "object"
        );
        if (!detailEntry) return origins;
        const detailObj = detailEntry[1];

        // 2) images(...) 객체 찾기
        const imagesEntry = Object.entries(detailObj)
        .find(([key, val]) =>
            key.startsWith("images") &&
            val &&
            Array.isArray(val.images)
        );
        if (!imagesEntry) return origins;
        const imagesArr = imagesEntry[1].images;

        // 3) origin 필드만 수집
        for (const imgObj of imagesArr) {
            if (imgObj && typeof imgObj.origin === "string") {
                origins.push(imgObj.origin);
            }
        }

        return origins;
    }

    const whenNextButtonClicked = async (step) => {
        if (!selectedFile) return;
        if(step==6 && !selectedFile.hotple) return;
        if(step>6 && !selectedFile.file_url) return;

        setIsLoading(true);
        try {
            const props = JSON.parse(await getAdviseProps(selectedFile.id));

            const res     = await fetch(selectedFile.file_url, { cache: 'reload' });
            if (!res.ok) throw new Error(`Failed to load .adv: ${res.status}`);
            let advData = null;

            if(step>6){
                const text = await res.text();
                advData = JSON.parse(text);
            }

            let originals = [];
            const officialImagesUrls = extractOfficialImageUrls(props[4]?.place) || [];
            const selectedUrls = [
                ...officialImagesUrls
                    .filter((_, idx) => (props[6]?.selectedOfficialImages || []).includes(idx)),
                ...(props[6]?.selectedImages || [])
                    .map(([b, i]) => props[4]?.blogImageUrls?.[b]?.[i])
                    .filter(url => typeof url === 'string')
            ];
            if (selectedUrls.length > 0) {
                const origRes = await axios.post(
                    'https://hotple.today/win-api/api/blog-image',
                    { image_urls: selectedUrls, need_compress: false }
                );
                originals = origRes.data.images;
            }

            const blogImageUrls = props[4]?.blogImageUrls || [];
            const blogs = blogImageUrls.map(urls => urls.map(() => undefined));

            // 3) extractOfficialImageUrls 길이만큼 officials 초기화
            const officials  = Array(officialImagesUrls.length).fill(undefined);

            // 4) 선택된 공식 이미지 인덱스, 블로그 이미지 쌍
            const officialIdxs = (stepProps[6]?.selectedOfficialImages || []).slice().sort((a, b) => a - b);
            const blogPairs    = props[6]?.selectedImages           || [];

            // 5) officials 채워넣기
            officialIdxs.forEach((origIdx, i) => {
                if (origIdx >= 0 && origIdx < officials.length) {
                    officials[origIdx] = originals[i];
                }
            });

            // 6) blogs 채워넣기
                blogPairs.forEach(([b, i], j) => {
                if (
                    b >= 0 && b < blogs.length &&
                    Array.isArray(blogs[b]) &&
                    i >= 0 && i < blogs[b].length
                ) {
                    blogs[b][i] = originals[ officialIdxs.length + j ];
                }
            });

            const gifImages = {};
            blogPairs.forEach(([b, i], j) => {
                const url = props[4]?.blogImageUrls?.[b]?.[i] || '';
                if (url.toLowerCase().endsWith('.gif')) {
                    // originals 배열에서 공식 이미지 뒷부분 j번째
                    gifImages[`${b}-${i}`] = originals[officialIdxs.length + j];
                }
            });

            const statusMap = {
                '승인 필요':   'before',
                '승인 대기':   'pending',
                '승인 완료':   'approve',
                '승인 거절':   'denied',
            };

            const resourceStatus = selectedFile.resources.reduce((acc, res) => {
                const key = statusMap[res.status];
                if (!key) return acc;        // 매핑에 없으면 무시
                acc[key].push(res.author_name);
                return acc;
            }, {
                before:  [],
                pending: [],
                approve: [],
                denied:  []
            });
        
            setStepProps(prev => {
                const newProps = [...props];
                newProps[0] = prev[0];
                newProps[6] = {
                    ...props[6],
                    blogImages: blogs,
                    officialImages: officials,
                    gifImages: gifImages,
                };
                newProps[7] = {
                    ...props[7],
                    originalImages: originals,
                };
                newProps[8] = {
                    ...props[8],
                    file: advData,
                };
                newProps[9] = props[9];
                newProps[10] = {
                    ...props[10],
                    resourceStatus: resourceStatus
                };
                return newProps;
            });
            setAdViseStep(step);
        } catch (err) {
            console.error('Error loading Advise project file:', err);
            alert('파일을 불러오는 중 오류가 발생했습니다.');
        } finally {
            setIsLoading(false);
        }
    };

    const byRegion = regionFilter === '전체' ? files : files.filter(f => f.region === regionFilter);

    // ───── region별 전체 개수 계산
    const regionCounts = REGION_OPTIONS.reduce((acc, region) => {
        acc[region] = files.filter(file =>
        region==='전체' ? true : file.region === region
        ).length;
        return acc;
    }, {});
    
    // ───── 현재 선택된 region 내에서 카테고리별 개수 계산
    const categoryCounts = CATEGORY_OPTIONS.reduce((acc, key) => {
        if (key === '전체') {
          acc[key] = byRegion.length;
        } else if (key === '기타') {
          // hotple 정보가 없는 파일
          acc[key] = byRegion.filter(f => !f.hotple).length;
        } else {
          acc[key] = byRegion.filter(f => f.hotple?.main_category === key).length;
        }
        return acc;
    }, {});

    const statusCounts = {
        '전체':       byRegion.length,

        // 1) 업로드 완료
        '업로드 완료': byRegion.filter(f => f.is_uploaded).length,

        // 2) 업로드 대기: 아직 업로드 안 됐고, res 없거나 모두 승인 완료
        '업로드 대기': byRegion.filter(f =>
            !f.is_uploaded &&
            Array.isArray(f.resources) &&
            (
            f.resources.length === 0 ||
            f.resources.every(r => r.status === '승인 완료')
            )
        ).length,

        // 3) 승인 필요: 아직 업로드 안 됐고, 한 개라도 승인 필요/거절
        '승인 필요': byRegion.filter(f =>
            !f.is_uploaded &&
            Array.isArray(f.resources) &&
            f.resources.some(r => r.status === '승인 필요')
        ).length,

        // 4) 승인 대기: 위 세 가지가 아닌 나머지
        '승인 대기': byRegion.filter(f =>
            !f.is_uploaded &&
            Array.isArray(f.resources) &&
            !(  // 업로드 완료도 아니고
                f.resources.length === 0 ||
                f.resources.every(r => r.status === '승인 완료')  // 업로드 대기도 아니고
            ) &&
            !f.resources.some(r => r.status === '승인 필요')  // 승인 필요도 아니면
        ).length,
    };

    const whenBlogClicked = (url, authorName, placeName) => {
        const comment = `안녕하세요 ${authorName}님😊 저는 지역별 핫플레이스를 매일 한 장소씩 소개해주는 HOTPLE 인스타/페북 운영자입니다!

이번에 저희 팔로워 분들께 [${placeName}]${josa(placeName,'을를')} 소개드리구 싶어서 찾아보던 중에 예쁘게 잘 찍어주신 사진이 눈에 띄더라구요ㅎㅎ

혹시 ${placeName}${josa(placeName,'을를')} 소개할 때 ${authorName}님께서 찍어주신 사진을 함께 보여드려도 괜찮을지 여쭤봐도 될까요? (물론, 출처도 이미지 위에 꼭꼭 표기할게요!)

괜찮으시다면 ‘좋아요’나 짧게 '답글' 남겨주시면 정말 감사드리겠습니다🙇‍♀️

오늘도 기분 좋은 하루 보내세요💛`

        copyToClipboard(comment);
        window.open(url, '_blank');
    };

    const renderStatus = (file) => {
        // 1) 업로드 완료
        if (file.is_uploaded) {
            return { text: '업로드 완료', className: styles.ratingtext0 };
        }

        const res = Array.isArray(file.resources) ? file.resources : [];

        const allApproved = res.length > 0 && res.every(r => r.status === '승인 완료');
        const none       = res.length === 0;
        const anyNeed    = res.some(r => r.status === '승인 필요' || r.status === '승인 거절');

        if (none || allApproved) {
            return { text: '업로드 대기', className: styles.ratingtext2 };
        }
        if (anyNeed) {
            return { text: '승인 필요', className: styles.ratingtext };
        }
        return { text: '승인 대기', className: styles.ratingtext1 };
    };


    const getStatusClass = (status) => {
        switch (status) {
            case '승인 필요':
                return styles.needs;
            case '승인 거절':
                return styles.deny;
            case '승인 대기':
                return styles.pending;
            case '승인 완료':
                return styles.approved;
            default:
                return '';
        }
    };

    const cacheBustedUrl = (url) => {
        return `${url}?_=${Date.now()}`;
    }

    useEffect(() => {
        if (selectedFile) {
        const el = adviseRefs.current[selectedFile.id];
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [selectedFile, currentPage]);

    useEffect(() => {
        if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTo({ top: 0, behavior: 'instant' });
        }
    }, [currentPage]);

    useEffect(() => {
        getAdviseFiles();
    }, []);

    const resetPaging = () => {
        setCurrentPage(0);
        setSelectedFile(null);
    };

    return (
        <div className={styles.outerframe}>
            {captionModalOpen && (
            <div
                className={styles.modalOverlay}
                onClick={() => setCaptionModalOpen(false)}
            >
                <div
                className={styles.modalContent}
                onClick={e => e.stopPropagation()}
                >
                <button
                    className={styles.modalClose}
                    onClick={() => setCaptionModalOpen(false)}
                >
                    ×
                </button>
                <pre className={styles.modalBody}>
                    {captionModalText}
                </pre>
                </div>
            </div>
            )}
            <div className={styles.upperframe}>
                <img
                    className={styles.backbuttonIcon}
                    alt="뒤로가기"
                    src="images/back_android.svg"
                    onClick={() => setAdViseStep(0)}
                />
                <div className={styles.titleframe}>
                    <b className={styles.nextbuttontext}>AdVise 프로젝트</b>
                    <div className={styles.stepdesc}>
                        원하는 AdVise 프로젝트 선택!
                    </div>
                </div>
                <label className={styles.safeAreaToggle}>
                    <div className={styles.thumbnailFrame}>
                        <input
                            type="checkbox"
                            checked={showImages}
                            onChange={e => setShowImages(e.target.checked)}
                        />
                        <>썸네일</>
                    </div>
                </label>
            </div>

            {/* 리스트 영역 */}
            <div
                className={styles.lowerframe}
                id="advise-items-container"
                style={{ height: `calc(100dvh - ${marginTop}px - 103px - 74px)` }}
                ref={scrollContainerRef}
            >
                <div className={styles.contentframe}>
                    {/* 지역 필터 */}
                    <div className={styles.categorybuttons}>
                        <div className={styles.div3}>
                            <div className={styles.list}>
                            {REGION_OPTIONS.map(region => (
                                <div
                                key={region}
                                className={regionFilter === region
                                    ? styles.buttonplaceCategorySelected
                                    : styles.buttonplaceCategory}
                                onClick={() => { setRegionFilter(region); resetPaging(); }}
                                >
                                <div className={styles.label2}>
                                    {region}({regionCounts[region]})
                                </div>
                                </div>
                            ))}
                            </div>
                        </div>
                    </div>

                    {/* 카테고리 필터 */}
                    <div className={styles.categorybuttons}>
                        <div className={styles.div3}>
                            <div className={styles.list}>
                                <div className={categoryFilter==='전체'?styles.buttonplaceCategorySelected:styles.buttonplaceCategory}onClick={()=>{setCategoryFilter('전체');resetPaging();}}>
                                    <img className={styles.iconstarFilled} src="images/star_filled.svg" alt="전체"/>
                                    <div className={styles.label2}>전체({categoryCounts['전체']})</div>
                                </div>
                                <div className={categoryFilter==='음식점'?styles.buttonplaceCategorySelected:styles.buttonplaceCategory} onClick={()=>{setCategoryFilter('음식점');resetPaging();}}>
                                    <img className={styles.iconstarFilled} src="images/restaurant.svg" alt="음식점"/>
                                    <div className={styles.label2}>음식점({categoryCounts['음식점']})</div>
                                </div>
                                <div className={categoryFilter==='주점'?styles.buttonplaceCategorySelected:styles.buttonplaceCategory} onClick={()=>{setCategoryFilter('주점');resetPaging();}}>
                                    <img className={styles.iconstarFilled} src="images/alcohol.svg" alt="주점"/>
                                    <div className={styles.label2}>주점({categoryCounts['주점']})</div>
                                </div>
                                <div className={categoryFilter==='카페디저트'?styles.buttonplaceCategorySelected:styles.buttonplaceCategory} onClick={()=>{setCategoryFilter('카페디저트');resetPaging();}}>
                                    <img className={styles.iconstarFilled} src="images/cafe.svg" alt="카페디저트"/>
                                    <div className={styles.label2}>카페디저트({categoryCounts['카페디저트']})</div>
                                </div>
                                <div className={categoryFilter==='팝업스토어'?styles.buttonplaceCategorySelected:styles.buttonplaceCategory} onClick={()=>{setCategoryFilter('팝업스토어');resetPaging();}}>
                                    <img className={styles.iconstarFilled} src="images/popupStore.svg" alt="팝업스토어"/>
                                    <div className={styles.label2}>팝업스토어({categoryCounts['팝업스토어']})</div>
                                </div>
                                <div className={categoryFilter==='오락액티비티'?styles.buttonplaceCategorySelected:styles.buttonplaceCategory} onClick={()=>{setCategoryFilter('오락액티비티');resetPaging();}}>
                                    <img className={styles.iconstarFilled} src="images/activity.svg" alt="오락액티비티"/>
                                    <div className={styles.label2}>오락액티비티({categoryCounts['오락액티비티']})</div>
                                </div>
                                <div className={categoryFilter==='문화예술'?styles.buttonplaceCategorySelected:styles.buttonplaceCategory} onClick={()=>{setCategoryFilter('문화예술');resetPaging();}}>
                                    <img className={styles.iconstarFilled} src="images/smile.svg" alt="문화예술"/>
                                    <div className={styles.label2}>문화예술({categoryCounts['문화예술']})</div>
                                </div>
                                <div className={categoryFilter==='숙소'?styles.buttonplaceCategorySelected:styles.buttonplaceCategory} onClick={()=>{setCategoryFilter('숙소');resetPaging();}}>
                                    <img className={styles.iconstarFilled2} src="images/home_filled.svg" alt="숙소"/>
                                    <div className={styles.label2}>숙소({categoryCounts['숙소']})</div>
                                </div>
                                <div className={categoryFilter==='휴식힐링'?styles.buttonplaceCategorySelected:styles.buttonplaceCategory} onClick={()=>{setCategoryFilter('휴식힐링');resetPaging();}}>
                                    <img className={styles.iconstarFilled} src="images/flower.svg" alt="휴식힐링"/>
                                    <div className={styles.label2}>휴식힐링({categoryCounts['휴식힐링']})</div>
                                </div>
                                <div className={categoryFilter==='기타'?styles.buttonplaceCategorySelected:styles.buttonplaceCategory} onClick={()=>{setCategoryFilter('기타');resetPaging();}}>
                                    <div className={styles.label2}>기타({categoryCounts['기타']})</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.categorybuttons}>
                        <div className={styles.div3}>
                            <div className={styles.list}>
                                <div
                                    className={statusFilter === '전체' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}
                                    onClick={() => { setStatusFilter('전체'); resetPaging(); }}
                                >
                                    <div className={styles.label2}>전체({statusCounts['전체']})</div>
                                </div>
                                <div
                                    className={statusFilter === '승인 필요' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}
                                    onClick={() => { setStatusFilter('승인 필요'); resetPaging(); }}
                                >
                                    <div className={styles.label2}>승인 필요({statusCounts['승인 필요']})</div>
                                </div>
                                <div
                                    className={statusFilter === '승인 대기' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}
                                    onClick={() => { setStatusFilter('승인 대기'); resetPaging(); }}
                                >
                                    <div className={styles.label2}>승인 대기({statusCounts['승인 대기']})</div>
                                </div>
                                <div
                                    className={statusFilter === '업로드 대기' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}
                                    onClick={() => { setStatusFilter('업로드 대기'); resetPaging(); }}
                                >
                                    <div className={styles.label2}>업로드 대기({statusCounts['업로드 대기']})</div>
                                </div>
                                <div
                                    className={statusFilter === '업로드 완료' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}
                                    onClick={() => { setStatusFilter('업로드 완료'); resetPaging(); }}
                                >
                                    <div className={styles.label2}>업로드 완료({statusCounts['업로드 완료']})</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 검색 */}
                    <div className={styles.searchFrame}>
                        <AutoCompleteInput
                            filterText={filterText}
                            setFilterText={text => {
                                handleFilterTextChange(text);
                            }}
                            whenHotpleClicked={file => {
                                setFilterText(file.name);
                                setSelectedFile(file);
                            }}
                            suggestions={filteredFiles}
                        />
                        {filterText && (
                            <div className={styles.div} onClick={() => {
                                setFilterText('');
                                resetPaging();
                            }}>
                                <img
                                className={styles.iconsearch2}
                                alt="검색어 지우기"
                                src="images/close_filled.svg"
                                />
                            </div>
                        )}
                    </div>

                    {/* 아이템 */}
                    {currentFilePage.map(file => (
                        <div
                        key={file.id}
                        id={`advise-item-${file.id}`}
                        className={
                            selectedFile?.id === file.id
                            ? styles.hotpleItemFrameSelected
                            : styles.hotpleItemFrame
                        }
                        onClick={() => setSelectedFile(file)}
                        ref={el => (adviseRefs.current[file.id] = el)}
                        >
                        
                        <div className={styles.iconcloseLineParent}>
                            <div className={styles.commentframe} onClick={(e)=>e.stopPropagation()}>
                                <select
                                    className={styles.ratioSelect2}
                                    value={file.region}
                                    onMouseDown={e => {
                                        if (file.is_uploaded) {
                                            e.preventDefault();  // 드롭다운 자체가 열리지 않도록 막음
                                            alert('이미 업로드된 프로젝트는 지역을 변경할 수 없습니다.');
                                        }
                                    }}
                                    onChange={e => {
                                        const oldRegion = file.region;
                                        const newRegion = e.target.value;

                                        if (oldRegion === newRegion) return;  // 변경 없으면 패스

                                        // confirm 창 띄우기
                                        if (window.confirm(`'${file.name}' 프로젝트의 업로드 지역을 '${oldRegion}'에서 '${newRegion}'로 변경하시겠습니까?`)) {
                                        handleRegionChange(file.id, newRegion);
                                        }
                                    }}
                                >
                                    {REGION_OPTIONS.filter(r => r!='전체').map(r => (
                                        <option key={r} value={r}>{r}</option>
                                    ))}
                                </select>
                            </div>
                            <div className={styles.ratingframe}>
                                <div {...(() => {
                                    const { text, className } = renderStatus(file);
                                    return {
                                        className,
                                        children: `${text} (${file.updated_device}) - ${file.contents_url.filter(url => !url.includes('facebook')).length}장`
                                    };
                                })()} />
                            </div>
                            <img className={styles.iconcloseLine} onClick={e => { e.stopPropagation(); handleClone(file.id, file.name); }} src="images/clone.svg" alt="복제" />
                            <img className={styles.iconcloseLine} onClick={(event)=> {event.stopPropagation(); whenDeleteButtonClicked(file.id);}} alt="" src="images/close_line.svg" />
                        </div>
                        {/* 썸네일 */}
                        {file.file_url && showImages &&
                            <div className={styles.imageframe}>
                                {(file.contents_url.length > 0 && file.contents_url.filter(url => !url.includes('facebook')).map((url, idx) => (
                                    <div
                                        key={idx}
                                        className={
                                            idx === 0 ? styles.image1frame : styles.image2frame
                                        }
                                        style={{ marginLeft: idx === 0 ? '12px' : 0 }}
                                    >
                                        <LazyLoad
                                            height={152}
                                            offset={333}
                                            once
                                            scrollContainer="#advise-items-container"
                                        >
                                            {url.includes('.mp4') ? (
                                            <video
                                                className={
                                                idx === 0
                                                    ? styles.image1Icon
                                                    : styles.image3Icon
                                                }
                                                src={cacheBustedUrl(url)}
                                                loop
                                                autoPlay
                                                playsInline
                                                muted
                                            />
                                            ) : (
                                            <img
                                                className={
                                                idx === 0
                                                    ? styles.image1Icon
                                                    : styles.image3Icon
                                                }
                                                alt=""
                                                src={cacheBustedUrl(url)}
                                            />
                                            )}
                                        </LazyLoad>
                                    </div>
                                )))}

                                {/* .adv 파일 아이콘 */}
                                {file.file_url && (
                                <div
                                    className={styles.image2frame}
                                    onClick={() => downloadAllContents(file.contents_url)}
                                    style={{ paddingRight: '12px' }}
                                >
                                    <div className={styles.infoframe2}>
                                    <div className={styles.infos}>
                                        <img
                                        className={styles.iconshare}
                                        alt=""
                                        src="images/share.svg"
                                        />
                                        <div className={styles.div}>
                                        <span className={styles.txt}>
                                            <p className={styles.p}>결과물</p>
                                            <p className={styles.p}>다운로드</p>
                                        </span>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                )}
                            </div>
                        }

                        {Array.isArray(file.resources) && file.resources.length > 0 && (
                            <div className={styles.resourcesFrame}>
                                <div className={styles.resourcesTitle}>리소스<br/>상태</div>
                                {[...file.resources]
                                .sort((a, b) => {
                                    const aUsed = file.used_resource.includes(a.id);
                                    const bUsed = file.used_resource.includes(b.id);
                                    if (aUsed === bUsed) return 0;
                                    return aUsed ? -1 : 1;  // aUsed 이면 앞으로, 아니면 뒤로
                                })
                                .map(res => {
                                    const statusClass = getStatusClass(res.status);
                                    const isUsed = file.used_resource.includes(res.id);
                                    return (
                                    <div
                                        key={res.id}
                                        className={isUsed ? styles.resourceRowUsed : styles.resourceRow}
                                        onClick={(e)=>e.stopPropagation()}
                                    >
                                        <div
                                        onClick={() => whenBlogClicked(res.url, res.author_name, file.hotple.name)}
                                        className={`${styles.resourceLink} ${statusClass}`}
                                        >
                                        {res.author_name}
                                        </div>
                                        <select
                                        className={`${styles.ratioSelect} ${statusClass}`}
                                        value={res.status}
                                        onChange={e => handleResourceStatusChange(file.id, res.author_name, e.target.value)}
                                        >
                                        <option value="승인 필요">승인 필요</option>
                                        <option value="승인 대기">승인 대기</option>
                                        <option value="승인 완료">승인 완료</option>
                                        <option value="승인 거절">승인 거절</option>
                                        </select>
                                    </div>
                                    );
                                })}
                            </div>
                        )}

                        {/* 텍스트 */}
                        <div className={styles.detailframe}>
                            <div className={styles.detailleft}>
                            <div className={styles.title}>
                                <div className={styles.hotplename}>{file.name}</div>
                                <img className={styles.iconcloseLine2} onClick={e => { e.stopPropagation(); handleRename(file.id, file.name); }} src="images/pen.svg" alt="이름 변경" />
                                {file.caption && <img className={styles.iconcloseLine2} onClick={e => { e.stopPropagation(); openCaptionModal(file.caption); }} src="images/info.svg" alt="캡션 보기" />}
                            </div>
                            {file.hotple && (
                                <div className={styles.tags}>
                                    <div className={styles.tagplaceDetail}>
                                        <div className={styles.orange}>[{file.hotple.region}] {file.hotple.name}</div>
                                    </div>
                                    <div className={styles.tagplaceDetail1}>
                                        <div className={styles.orange}>{file.hotple.main_category} ▸ {file.hotple.sub_category1} ▸ {file.hotple.sub_category2}</div>
                                    </div>
                                </div>
                            )}
                            <div className={styles.commentframe}>
                                <div className={styles.label}>생성</div>
                                {file.created_by_user_id} ({new Date(file.created_at).toLocaleString()})
                            </div>
                            <div className={styles.commentframe}>
                                <div className={styles.label}>수정</div>
                                {file.updated_by_user_id} ({new Date(file.updated_at).toLocaleString()})
                            </div>
                            {file.is_uploaded &&
                                <div className={styles.commentframe}>
                                    <div className={styles.label}>업로드</div>
                                    {file.uploaded_by_user_id} ({new Date(file.uploaded_at).toLocaleString()})
                                </div>
                            }
                            {file.instagram_media.length > 0 && (
                                <div className={styles.commentframe1}>
                                    <div className={styles.label5}>인스타:</div>
                                    {file.instagram_media.map(media => (
                                        <div
                                            key={media.region}
                                            className={styles.label1}
                                            onClick={() => openInstagramMedia(media.media_url)}
                                        >
                                            {media.region}
                                        </div>
                                    ))}
                                </div>
                            )}
                            {file.facebook_media.length > 0 && (
                                <div className={styles.commentframe1}>
                                    <div className={styles.label6}>페북:</div>
                                    {file.facebook_media.map(media => (
                                        <div
                                            key={media.region}
                                            className={styles.label1}
                                            onClick={() => openInstagramMedia(media.media_url)}
                                        >
                                            {media.region}
                                        </div>
                                    ))}
                                </div>
                            )}
                            </div>
                            <div className={styles.detailrightbutton}>
                                {file.hotple_id && (
                                    <img
                                    className={styles.iconlikeOutlined}
                                    alt="미리보기"
                                    src="logo192.png"
                                    onClick={() =>
                                        window.open(
                                        `https://app.hotple.today?menu=admin&hotple_id=${file.hotple_id}`,
                                        '_blank'
                                        )
                                    }
                                    />
                                )}
                                {file.hotple?.naver_map_place_id && (
                                    <img
                                    className={styles.iconlikeOutlined2}
                                    alt="네이버지도"
                                    src="images/naver.svg"
                                    onClick={() =>
                                        window.open(
                                        `https://m.place.naver.com/place/${file.hotple.naver_map_place_id}/home`,
                                        '_blank'
                                        )
                                    }
                                    />
                                )}
                            </div>
                        </div>
                        </div>
                    ))}

                    {/* 페이징 */}
                    {totalPages > 1 && (
                        <div className={styles.pagination}>
                        <div
                            className={styles.pageButton}
                            onClick={() => {
                            setCurrentPage(p => Math.max(p - 1, 0));
                            setSelectedFile(null);
                            }}
                            style={{
                            cursor: currentPage === 0 ? 'default' : 'pointer',
                            opacity: currentPage === 0 ? 0.5 : 1
                            }}
                        >
                            ◀
                        </div>
                        <div className={styles.pageIndex}>
                            {currentPage + 1} / {totalPages}
                        </div>
                        <div
                            className={styles.pageButton}
                            onClick={() => {
                            setCurrentPage(p => Math.min(p + 1, totalPages - 1));
                            setSelectedFile(null);
                            }}
                            style={{
                            cursor: currentPage >= totalPages - 1 ? 'default' : 'pointer',
                            opacity: currentPage >= totalPages - 1 ? 0.5 : 1
                            }}
                        >
                            ▶
                        </div>
                    </div>
                )}

                <img
                    className={styles.topButton}
                    alt="맨 위로"
                    src="images/chevron_bottom.svg"
                    onClick={whenScrollTopClicked}
                />
                </div>
            </div>

            {/* 하단 버튼 */}
            <div className={styles.nextbuttonframe}>
                <div className={selectedFile && selectedFile.hotple ? styles.nextbutton : styles.nextbuttonDisabled}
                    onClick={() =>whenNextButtonClicked(6)}>
                    <b className={styles.nextbuttontext}>리소스 선택 →</b>
                </div>

                <div className={selectedFile && selectedFile.file_url ? styles.nextbutton : styles.nextbuttonDisabled}
                  onClick={() => whenNextButtonClicked(8)}>
                    <b className={styles.nextbuttontext}>콘텐츠 편집 →</b>
                </div>

                <div className={selectedFile && selectedFile.file_url ? styles.nextbutton : styles.nextbuttonDisabled}
                  onClick={() => whenNextButtonClicked(9)}>
                    <b className={styles.nextbuttontext}>본문 편집 →</b>
                </div>
            </div>
            {isLoading &&
                <div className={styles.loadingFrame}>
                    <div className={styles.loader}/>
                    <div className={styles.loadingText}>
                    프로젝트 로드 중...
                    </div>
                </div>
            }
        </div>
    );
};

export default AdViseFileViewer;